const formatToCurrencyBr = (value) => {
  const money = parseFloat(value)
  return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

function searchValue(obj, key) {
  let result = null

  // eslint-disable-next-line
  if (obj.hasOwnProperty(key)) {
    return obj[key]
  }

  // eslint-disable-next-line
  Object.values(obj).some((value) => {
    if (typeof value === 'object') {
      result = searchValue(value, key)
      return result !== null
    }
  })
  return result
}

function getFirstPropertyName(obj) {
  const keys = Object.keys(obj)
  if (keys.length > 0) {
    return keys[0]
  }
  return null
}

const getValueNote = (value) => {
  const xml = value

  const structure = [
    {
      name: 'GovDigital',
      array: true,
      format: 'Global',
      value: [{ amount: 'valorBase', netValue: 'valorLiquido' }],
    },
    {
      name: 'ListaNotaFiscal',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'nfeProc',
      array: true,
      format: 'Global',
      value: [{ amount: 'vProd', netValue: 'vNF' }],
    },
    {
      name: 'NOTAS_FISCAIS',
      array: true,
      format: 'Global',
      value: [{ amount: 'VALOR_NOTA', netValue: 'VALOR_SERVICO' }],
    },
    {
      name: 'nfse',
      array: true,
      format: 'Global',
      value: [
        { amount: 'valor_total', netValue: 'valor_total' },
        { amount: 'valorBase', netValue: 'valorLiquido' },
      ],
    },
    {
      name: 'NFSE',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'Nfse',
      array: true,
      format: 'Global',
      value: [
        { amount: 'ValorLiquidoNfse', netValue: 'ValorLiquidoNfse' },
        { amount: 'BaseCalculo', netValue: 'ValorTotalNota' },
        { amount: 'BaseCalculo', netValue: 'ValorLiquidoNfse' },
      ],
    },
    {
      name: 'ListaNfse',
      array: true,
      format: 'Global',
      value: [{ amount: 'BaseCalculo', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'ConsultarNfseResposta',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'NFSe',
      array: true,
      format: 'Global',
      value: [{ amount: 'vServ', netValue: 'vLiq' }],
    },
    {
      name: 'ii:ConsultaRPSCompetencia',
      array: true,
      format: 'Global',
      value: [{ amount: 'ii:BaseCalculo', netValue: 'ii:ValorLiquidoNfse' }],
    },
    {
      name: 'ConsultarNfseServicoPrestadoResposta',
      array: true,
      format: 'Global',
      value: [{ amount: 'BaseCalculo', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'NFe',
      array: true,
      format: 'Br',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'xmlNfpse',
      array: true,
      format: 'Global',
      value: [{ amount: 'valorTotalServicos', netValue: 'valorTotalServicos' }],
    },
    {
      name: 'SDTNotasExport',
      array: true,
      format: 'Global',
      value: [{ amount: 'VlBasCalc', netValue: 'ValorNFS' }],
    },
    {
      name: 'CompNfse',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'outputXML',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
    {
      name: 'GerarNfseResposta',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },

    {
      name: 'notas',
      array: true,
      format: 'Global',
      value: [
        { amount: 'valor_servico', netValue: 'valor_liquido_nfse' },
        { amount: 'valorServico', netValue: 'valorLiquido' },
      ],
    },
    {
      name: 'listaNfe',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorBase', netValue: 'ValorLiquido' }],
    },
    {
      name: 'tcNFSe',
      array: true,
      format: 'Br',
      value: [{ amount: 'tsVlrSvc', netValue: 'tsVlrLiq' }],
    },
    {
      name: 'tcLotNFE',
      array: true,
      format: 'Br',
      value: [{ amount: 'tsBasCalc', netValue: 'tsVlrSvc' }],
    },
    {
      name: 'tcListaNFse',
      array: true,
      format: 'Global',
      value: [{ amount: 'ValorServicos', netValue: 'ValorLiquidoNfse' }],
    },
  ]

  const typeOfXml = getFirstPropertyName(xml)
  if (!typeOfXml) {
    return null
  }

  const structureNote = structure.find((item) => item.name === typeOfXml)
  if (!structureNote) {
    return null
  }

  let valueNote = null
  let netValueNote = null

  structureNote.value.forEach((item) => {
    if (valueNote === null) {
      // eslint-disable-next-line no-shadow
      let value = searchValue(xml, item.amount)
      if (value && structureNote.array) {
        // eslint-disable-next-line prefer-destructuring
        value = value[0]
      }
      if (value && value.includes('R$')) {
        value = value.replace('R$ ', '')
        value = value.replace('.', '')
        value = value.replace(',', '.')
      }
      if (value && value.includes('.') && value.includes(',')) {
        value = value.replace('.', '')
        value = value.replace(',', '.')
      }
      if (value) {
        valueNote = value
      }
    }

    if (netValueNote === null) {
      // eslint-disable-next-line no-shadow
      let value = searchValue(xml, item.netValue)
      if (value && structureNote.array) {
        // eslint-disable-next-line prefer-destructuring
        value = value[0]
      }
      if (value && value.includes('R$')) {
        value = value.replace('R$ ', '')
        value = value.replace('.', '')
        value = value.replace(',', '.')
      }
      if (value && value.includes('.') && value.includes(',')) {
        value = value.replace('.', '')
        value = value.replace(',', '.')
      }
      if (value) {
        netValueNote = value
      }
    }
  })

  return {
    valorTotal: parseFloat(valueNote),
    valorLiquido: parseFloat(netValueNote),
  }
}

export { formatToCurrencyBr, getValueNote }
